(function() {
  'use strict';

  var CACHE_KEY = 'yoxyox_azn_rate';
  var CACHE_TTL = 3 * 60 * 60 * 1000; // 3 saat
  var API_URL = 'https://api.exchangerate-api.com/v4/latest/USD';

  function getRate(cb) {
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        var obj = JSON.parse(cached);
        if (Date.now() - obj.ts < CACHE_TTL) {
          cb(obj.rate);
          return;
        }
      }
    } catch(e) {}

    fetch(API_URL)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var rate = data.rates && data.rates.AZN ? data.rates.AZN : 1.7;
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify({ rate: rate, ts: Date.now() }));
        } catch(e) {}
        cb(rate);
      })
      .catch(function() {
        cb(1.7); // fallback məzənnə
      });
  }

  function parseUSD(el) {
    // MLV və ya Shopify tərəfindən dəyişdirilmiş mətn
    var txt = el.textContent || '';
    // "$19.99 USD", "$19.99", "19.99" formatlarını dəstəklə
    var match = txt.match(/[\d,]+\.?\d*/);
    if (!match) return null;
    return parseFloat(match[0].replace(/,/g, ''));
  }

  function formatAZN(amount) {
    return amount.toFixed(2) + ' AZN';
  }

  function applyRates(rate) {
    document.querySelectorAll('.money').forEach(function(el) {
      // Artıq işlənibsə keç
      if (el.dataset.yxDone) return;
      var usd = parseUSD(el);
      if (!usd || isNaN(usd)) return;
      var azn = usd * rate;
      el.dataset.yxDone = '1';
      el.dataset.yxUsd = usd;
      el.textContent = formatAZN(azn);
    });
  }

  function init() {
    getRate(function(rate) {
      applyRates(rate);
      // DOM dəyişikliklərinə reaksiya ver (cart refresh, quickview və s.)
      var obs = new MutationObserver(function() {
        applyRates(rate);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
